import { module as Module } from 'modujs';

export default class DarkHeader extends Module {
    static INVIEW_CLASS = 'has-dark-hero-inview';

    constructor(m) {
        super(m);
    }

    // =============================================================================
    // Lifecycle
    // =============================================================================
    destroy() {
        super.destroy();
    }

    // =============================================================================
    // Callbacks
    // =============================================================================
    onInview(e) {
        document.documentElement.classList.toggle(DarkHeader.INVIEW_CLASS, e.way == 'enter');
    }
}
